import React from "react"

const Footer = () => {
  return (
    <section className="footer">
      <p className="text-right">Bartosz Ciąpała 2020</p>
    </section>
  )
}

export default Footer
